// removed by extract-text-webpack-plugin
module.exports = {"base":"Arenas_base--3e2pL","item":"Arenas_item--1QiG2","caption":"Arenas_caption--2ToII"};


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Arenas/Arenas.scss
// module id = 481
// module chunks = 11 12